import type { HexString } from "@/types/general.types";
import { encoding, serializeLayout } from "@wormhole-foundation/sdk-connect";
import { relayInstructionsLayout } from "@wormhole-foundation/sdk-definitions";

/**
 * Encodes a minimal GasInstruction payload for Wormhole Executor quote requests.
 * Uses Wormhole's canonical relay instruction layout.
 */
export const encodeGasRelayInstruction = (
  gasLimit: bigint,
  msgValue: bigint = BigInt(0),
): HexString => {
  const serialized = serializeLayout(relayInstructionsLayout, {
    requests: [
      {
        request: {
          type: "GasInstruction",
          gasLimit,
          msgValue,
        },
      },
    ],
  });
  return `0x${encoding.hex.encode(serialized)}` as HexString;
};
